import { Component } from '@angular/core';
import { Router, NavigationEnd, Event, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ModalService } from './services/modal.service';
import { PageviewsettingsService } from './services/pageviewsettings.service';
import * as Globals from '../globals';

declare let analytics: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  showHeaderFooter = true;
  isLandingPage = false;
  isModalOpen = false;
  tenantId: number | undefined;
  affiliateId: any;
  loadeddata: any;
  favicon: any = document.querySelector('#favicon');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: ModalService,
    private settingsService: PageviewsettingsService
  ) {
 
    this.router.events
      .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {

       
        if (event.url.includes('/shop-faculty-plans')) {
          localStorage.setItem('facultyEnabled', 'true');
        } else if (event.url.includes('/shop-faculty-plans2')) {
          localStorage.setItem('facultyEnabled', 'false');
        }
        
        this.applyCollegeTheme();

        // Analytics tracking
        analytics.page({
          path: event.urlAfterRedirects,
          name: this.getPageName(event.urlAfterRedirects),
          properties: { timestamp: new Date() }
        });

        
        const hideOnRoutes = ['/', '/default', '/search'];
        this.showHeaderFooter = !hideOnRoutes.includes(event.urlAfterRedirects);
      });

    this.modalService.modalState$.subscribe(open => this.isModalOpen = open);
  }

  
  private applyCollegeTheme() {
    let currentRoute = this.route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const collegemobile = currentRoute.snapshot.paramMap.get('collegemobile');
    if (!collegemobile) return;

    
    const savedColor = localStorage.getItem(`primaryColor_${collegemobile}`);
    if (savedColor) {
      document.documentElement.style.setProperty('--primary', savedColor);
    } else {
      
      document.documentElement.style.setProperty('--primary', this.getRouteFallbackColor(collegemobile));
    }

    this.settingsService.getCollegetenantcode(collegemobile).subscribe(data => {
      this.tenantId = parseInt(data.result.id);
      this.affiliateId = data.result.affiliateId;
      this.loadPageSettings(collegemobile);
    });
  }

  private loadPageSettings(college: string) {
    this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId)
     .subscribe(data => {
	    this.loadeddata = data.result;
		this.favicon.href = 'assets/tenants/' + college + Globals.IMAGE_FAVICON;
        const apiColor = this.loadeddata?.PrimaryColor;

        if (apiColor) {
          document.documentElement.style.setProperty('--primary', apiColor);
          localStorage.setItem(`primaryColor_${college}`, apiColor);
        }
      });
  }

  private getPageName(url: string): string {
    if (url.includes('landingpage')) return 'Landing page';
    if (url.includes('fan')) return 'Fan Plans';
    if (url.includes('student')) return 'Student Plans';
    if (url.includes('faculty')) return 'Faculty Plans';
    if (url.includes('why')) return 'Why Husky mobile';
    if (url.includes('coveragemap')) return 'Coverage Map';
    if(url.includes('giveawaypage2')) return 'Give Away Page 2';
    return 'Generic Page';
  }

  private getRouteFallbackColor(college: string): string {
    switch (college) {
      case 'huskymobile': return '#33006F';
      case 'bearsmobile': return '#123456';
      default: return '#4b2e83';
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }
}
